import { render } from "./BindingStep1View.vue?vue&type=template&id=1a06c9c5&scoped=true"
import script from "./BindingStep1View.vue?vue&type=script&lang=js"
export * from "./BindingStep1View.vue?vue&type=script&lang=js"

import "./assets/index.css?vue&type=style&index=0&id=1a06c9c5&scoped=true&lang=css"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a06c9c5"]])

export default __exports__